import React, { FC } from 'react';
import { View } from 'react-native';
import TouchableElement from '@components/common/touchableElement';

import { Element, scale } from '@components/frame';

import Svg from '@styles/icons/svg';

import { navigateBack, isWeb } from '@helpers';
import { ImageHandlingDisplayMode } from '@v2/components/imageHandling/types/types.d';
import { useManageThumbnailHeaderIcons } from '@v2/components/imageHandling/components/Thumbnail/components/ThumbnailHeader/hooks/useManageThumbnailHeaderIcons';

interface ThumbnailHeaderWebTabletIconsProps {
  setMode: (mode: ImageHandlingDisplayMode) => void;
  scrolled: boolean;
  onBackButtonPress?: () => void;
}

const ThumbnailHeaderWebTabletIcons: FC<ThumbnailHeaderWebTabletIconsProps> = ({ setMode, scrolled, onBackButtonPress }) => {
  const { onAddImagePress } = useManageThumbnailHeaderIcons();

  return (
    <View style={{ width: '100%', height: scale(48) }}>
      <Element
        {...{
          config: {
            position: {
              top: 6.5,
              left: 4,
            },
            zIndex: 10000,
          },
        }}
      >
        <TouchableElement onPress={() => (onBackButtonPress ? onBackButtonPress?.() : navigateBack())}>
          {({ boxStyle, pressHoverColor }) => (
            <View
              style={[
                boxStyle,
                {
                  width: scale(35),
                  height: scale(35),
                  justifyContent: 'center',
                  alignItems: 'center',
                },
              ]}
            >
              {scrolled && (
                <Svg icon="chevronLeft" width={scale(11)} height={scale(19)} includeScheme={!isWeb} color="Label/Dark/AlwaysLight Primary" />
              )}
              {!scrolled && <Svg icon="chevronLeft" width={scale(11)} height={scale(19)} includeScheme={!isWeb} color="Link / Dark / Primary" />}
            </View>
          )}
        </TouchableElement>
      </Element>
      <Element
        {...{
          config: {
            position: {
              top: 6.5,
              right: 126.5,
            },
          },
        }}
      >
        <TouchableElement onPress={() => setMode(ImageHandlingDisplayMode.PICTURE)}>
          {({ boxStyle }) => (
            <View
              style={[
                boxStyle,
                {
                  width: scale(35),
                  height: scale(35),
                  justifyContent: 'center',
                  alignItems: 'center',
                },
              ]}
            >
              {scrolled && <Svg icon="gallery" width={scale(26)} height={scale(22)} includeScheme={!isWeb} color="Label/Dark/AlwaysLight Primary" />}
              {!scrolled && <Svg icon="gallery" width={scale(26)} height={scale(22)} includeScheme={!isWeb} color="Link / Dark / Primary" />}
            </View>
          )}
        </TouchableElement>
      </Element>
      <Element
        {...{
          config: {
            position: {
              top: 6.5,
              right: 70.5,
            },
          },
        }}
      >
        <TouchableElement onPress={() => onAddImagePress()}>
          {({ boxStyle }) => (
            <View
              style={[
                boxStyle,
                {
                  width: scale(35),
                  height: scale(35),
                  justifyContent: 'center',
                  alignItems: 'center',
                },
              ]}
            >
              {scrolled && (
                <Svg
                  icon="plus"
                  width={scale(isWeb ? 24 : 20)}
                  height={scale(isWeb ? 24 : 20)}
                  includeScheme={!isWeb}
                  color="Label/Dark/AlwaysLight Primary"
                />
              )}
              {!scrolled && (
                <Svg
                  icon="plus"
                  width={scale(isWeb ? 24 : 20)}
                  height={scale(isWeb ? 24 : 20)}
                  includeScheme={!isWeb}
                  color="Link / Dark / Primary"
                />
              )}
            </View>
          )}
        </TouchableElement>
      </Element>
      {/* <Element
        {...{
          config: {
            position: {
              top: 6.5,
              right: 14.5,
            },
          },
        }}
      >
        <TouchableElement onPress={() => {}}>
          {({ boxStyle }) => (
            <View
              style={[
                boxStyle,
                {
                  width: scale(35),
                  height: scale(35),
                  justifyContent: 'center',
                  alignItems: 'center',
                },
              ]}
            >
              {scrolled && (
                <Svg
                  icon="more"
                  width={scale(isWeb ? 27 : 20)}
                  height={scale(isWeb ? 28 : 20)}
                  includeScheme={!isWeb}
                  color="Label/Dark/AlwaysLight Primary"
                />
              )}
              {!scrolled && (
                <Svg
                  icon="more"
                  width={scale(isWeb ? 27 : 20)}
                  height={scale(isWeb ? 28 : 20)}
                  includeScheme={!isWeb}
                  color="Link / Dark / Primary"
                />
              )}
            </View>
          )}
        </TouchableElement>
      </Element> */}
    </View>
  );
};

export default ThumbnailHeaderWebTabletIcons;
